export const columnFields = [
	'id',
	'usageId',
	'organizationId',
	'usageName',
	'takeoffTypeId',
	'wastage',
	'wastagePercentage',
	'createdAt',
	'updatedAt',
] as const;
